import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import { TransferRecordResponse } from 'types/transferRecord'

export const useLatestTransferRecord = (
  residentId: string,
  enabled: boolean
) => {
  const { data, isLoading } = useQuery(
    ['latest-transfer-record', residentId],
    async () => {
      const response = (await getJSON({
        url: `/api/residents/${residentId}/transfer-records?limit=1`
      })) as { result: TransferRecordResponse[] }
      return response.result?.[0] || null
    },
    { enabled: enabled && !!residentId }
  )

  return { latestRecord: data ?? null, isLoading }
}
